import { gql } from 'apollo-angular'

export const GET_SEAT_CHANGE_PRICE = gql`
  query SeatChangePrice($subscriptionId: Int!, $quantity: Int!) {
    seatChangePrice(subscriptionId: $subscriptionId, quantity: $quantity) {
      amount
      amountInclVat
    }
  }
`
